import { CSSProperties, ReactNode, forwardRef, useId } from 'react'
import { Floating } from '../Floating'
import { Button, Menu, MenuItem, SelectItem } from '@dashboard/ui'
import { DotsHorizontal } from '@/icons'

type OnChange = (value: SelectItem['value']) => void

type TableRowEditButtonSize = 'xs' | 'sm' | 'md'
type TableRowEditButtonVariant = 'outline' | 'tertiary'

interface GridRowEditButtonProps {
  options?: (SelectItem | undefined | false)[]
  style?: CSSProperties
  menuWidth?: string
  onChange: OnChange
  size?: TableRowEditButtonSize
  variant?: TableRowEditButtonVariant
  menuTestId?: string
  extra?: ReactNode
}

const ButtonMenu = (props: {
  options: SelectItem[]
  onClose?: () => void
  onChange: OnChange
  menuTestId?: string
}) => {
  const id = useId()
  const { options, onChange, onClose, menuTestId } = props
  return (
    <Menu datatestid={menuTestId} style={{ maxWidth: 'none', minWidth: '210px' }}>
      {options.map(option => (
        <MenuItem
          key={`menu-option-${id}-${option.value}`}
          {...option}
          variant={option.variant}
          onClick={e => {
            e.stopPropagation()
            e.preventDefault()
            if (onClose) {
              onClose()
            }
            onChange(option.value)
          }}
        >
          {option.children}
        </MenuItem>
      ))}
    </Menu>
  )
}

export const TableRowEditButton = forwardRef<HTMLDivElement, GridRowEditButtonProps>(function Select({
  style,
  size,
  variant = 'tertiary',
  options = [],
  onChange = [],
  menuTestId,
  extra,
}) {
  options = options.filter(it => !!it)

  return (
    <Floating
      stopPropagation={true}
      hasArrow={true}
      menu={
        <ButtonMenu
          menuTestId={menuTestId}
          options={options.filter(it => !!it) as SelectItem[]}
          onChange={onChange as OnChange}
        />
      }
      placement="bottom-end"
      referenceWidth={true}
    >
      <Button className="flex items-center gap-2 px-1" size={size} variant={variant} color="secondary" style={style}>
        <DotsHorizontal />
        {extra && <div>{extra}</div>}
      </Button>
    </Floating>
  )
})
